import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

const menuItems = [
  { path: '/', label: 'Home' },
  { path: '/features', label: 'Features' },
  { path: '/demo', label: 'Demo' },
  { path: '/pricing', label: 'Pricing' },
  { path: '/enterprise', label: 'Enterprise' },
  { path: '/vision', label: 'Vision' },
  { path: '/about', label: 'About' },
];

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 bg-gradient-to-b from-slate-800 to-slate-900 flex flex-col items-center justify-center gap-8 md:hidden">
      {menuItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/'}
          onClick={onClose}
          className={({ isActive }) =>
            cn(
              'text-xl font-medium tracking-tight transition-colors',
              isActive ? 'text-indigo-400' : 'text-slate-200 hover:text-white'
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
      <div className="absolute bottom-10 flex flex-col items-center gap-2">
        <div className="flex gap-4">
          <NavLink
            to="/terms"
            onClick={onClose}
            className="text-xs text-slate-600 hover:text-slate-400 transition-colors"
          >
            Terms
          </NavLink>
          <NavLink
            to="/privacy"
            onClick={onClose}
            className="text-xs text-slate-600 hover:text-slate-400 transition-colors"
          >
            Privacy
          </NavLink>
          <NavLink
            to="/investors"
            onClick={onClose}
            className="text-xs text-slate-600 hover:text-slate-400 transition-colors"
          >
            For Investors
          </NavLink>
        </div>
        <div className="text-sm text-slate-600">
          &copy; {new Date().getFullYear()} DialogMe Inc.
        </div>
      </div>
    </div>
  );
}
